import axios, { throwAxiosError } from './request';
import { InfoText } from '../Types/AppSettings';

const endpoint = `/appsettings/`;

export const getInfoTexts = async (): Promise<InfoText[] | null> => {
  try {
    const { data } = await axios.get(endpoint);
    if (data) {
      return data as InfoText[];
    }
  } catch (error) {
    throwAxiosError(error);
  }
  return null;
};

export default {};
